import { useSubscriptionsStore } from '.';

function useSubscriptionCard(subscriptionId) {
    const store = useSubscriptionsStore();

    const cardSignal = store.cardSignals.get(subscriptionId);
    const subscriptionsSignal = store.observed.subscriptions;
    void cardSignal;
    void subscriptionsSignal;

    return {
        connectedSchedules: store.connectedSchedules[subscriptionId] || [],
        availableSchedules: store.availableSchedules[subscriptionId] || [],
        details: store.subscriptionDetails[subscriptionId] || {},
    };
}

export default useSubscriptionCard;
